export default __webpack_public_path__ + "static/media/Temperature_03.e0a629fc.png";